import { render, staticRenderFns } from "./YellowButton.vue?vue&type=template&id=40df9984&scoped=true"
import script from "./YellowButton.vue?vue&type=script&lang=js"
export * from "./YellowButton.vue?vue&type=script&lang=js"
import style0 from "./YellowButton.vue?vue&type=style&index=0&id=40df9984&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40df9984",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40df9984')) {
      api.createRecord('40df9984', component.options)
    } else {
      api.reload('40df9984', component.options)
    }
    module.hot.accept("./YellowButton.vue?vue&type=template&id=40df9984&scoped=true", function () {
      api.rerender('40df9984', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/YellowButton.vue"
export default component.exports